<script>
import ItineraryDayProgramImageList from './ItineraryDayProgramImageList';
import TwFileUpload from '../TwFileUpload';

export default {
  name: 'ItineraryDayProgramImageModal',
  components: { TwFileUpload, ItineraryDayProgramImageList },
  props: {
    dayProgramId: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggled: true,
      localImages: [],
    };
  },
  methods: {
    update() {
      const orderedFileIds = this.localImages.map(item => item.id);
      this.$emit('update', {
        dayProgramId: this.dayProgramId,
        fileIds: orderedFileIds,
      });
    },
    upload(event) {
      this.$emit('upload', {
        dayProgramId: this.dayProgramId,
        images: event,
      });
    },
    move(event) {
      this.localImages = event;
    },
    remove(event) {
      this.$emit('remove', {
        dayProgramId: this.dayProgramId,
        image: event,
      });
    },
  },
  watch: {
    toggled(val) {
      if (!val) {
        this.$emit('close');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="1200px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>image</v-icon>
        <span>{{ $t('itinerary.edit.dayProgram.images.header') }}</span>
      </v-flex>
      <v-divider light/>
      <tw-file-upload
        :loading="loading"
        @upload="upload"
      />
      <itinerary-day-program-image-list
        :images="images"
        :loading="loading"
        @move="move"
        @remove="remove"
      />
      <v-divider light/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="!localImages.length"
          color="primary"
          flat
          @click="update"
        >
          {{ $t('buttons.update') }}
        </v-btn>
        <v-btn
          @click="toggled = false"
          color="primary"
          flat
        >
          {{ $t('buttons.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramImageModal.vue